import PanelDimensionContainer from './PanelDimensionContainer'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    chartTypeFilter: state.FILTERS.chartTypeFilter
  }
}

export default connect(mapStateToProps)(PanelDimensionContainer)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/PanelDimensionContainer/index.js